import React from 'react';

const ToolManagmentCard = (props) => {
  const classes = 
   "p-6 bg-white border border-[#EAECF0] shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)] rounded-xl"
    + (props.className || '');

  return <div className={classes}>{props.children}</div>;
};

export default ToolManagmentCard;
